// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__31o_l","consentsList":"PatientConsents_consentsList___bVzs","consentsListEmpty":"PatientConsents_consentsListEmpty__322Zu"};